var map = {
	"./agsreport.ts": "3be3",
	"./auth.ts": "cdd0",
	"./countriesoverview.ts": "6ae2",
	"./datamanager.ts": "d378",
	"./ddcreport.ts": "bbad",
	"./general.ts": "4ca3",
	"./user.ts": "9dba"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c58b";